import {
  FETCH_ACTIVITY_TYPES,
} from './constants'

const ONE_DAY = 86400000

export function fetchActivityTypes () {
  return (dispatch, getState, { mapmy }) => {
    return dispatch({
      type: FETCH_ACTIVITY_TYPES,
      payload: () => mapmy.listActivityTypes(),
      meta: {
        localCacheKey: 'activityTypes',
        localCacheDuration: ONE_DAY * 30,
      },
    })
  }
}
